import { type NextApiRequest, type NextPageContext } from 'next'
import nookies, { destroyCookie } from 'nookies'
import { APP_ENV, NODE_ENV } from 'shared/envs'

export interface RemoveOptions {
  ctx?: NextPageContext
  appEnv?: string
  domain?: string | null
}

export function getDomain(__appEnv__?: string) {
  const envDomain = __appEnv__ || APP_ENV()
  const testEnvironments = ['hml', 'sandbox', 'sdb']

  if (envDomain && testEnvironments.includes(envDomain)) {
    return 'stone.credit'
  }
  return 'conta.stone.com.br'
}

export function cookieOptions() {
  const secure = NODE_ENV() === 'production'
  return { secure, path: '/' }
}

function set(name: string, value: string, options?: any, __appEnv__?: string) {
  const { ctx, ...restOptions } = options || {}
  const domain = getDomain(__appEnv__)
  const defaultOptions = cookieOptions()

  nookies.set(ctx, name, value, { ...defaultOptions, ...restOptions })

  // Remove cookies from domain (if has domain)
  if (domain) destroyCookie(ctx, name, { domain })
}

function getAll(ctx?: NextPageContext | { req: NextApiRequest }) {
  return nookies.get(ctx)
}

function batchRemove(names: string[], ctx?: NextPageContext, __appEnv__?: string) {
  names.forEach(name => remove(name, { ctx, appEnv: __appEnv__ }))
}

function remove(name: string, options?: RemoveOptions) {
  // Cookies set with a dynamic domain (e.g. via getCookieDomain) must be removed with that same
  // domain — the env-based default below won't match it (see getDomain vs getCookieDomain).
  const domain = options?.domain || getDomain(options?.appEnv)
  // Remove cookies from domain
  destroyCookie(options?.ctx, name, { domain, path: '/' })

  // Remove any legacy cookies
  destroyCookie(options?.ctx, name, { path: '/' })
}

// isomorphic as in backend and frontend
export const isomorphicCookies = { set, batchRemove, getAll, remove }
